<div class="pt-3 pl-md-4" *ngIf="!accountService.getMyAccount().can_manage_events">
  <h2>You do not have permission to manage event discounts.</h2>
</div>

<div class="pt-3 pl-md-4" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3 pl-md-4 mb-6"
     *ngIf="accountService.getMyAccount().can_manage_events && serverError === null">

  <h2>
    Event Discounts
    <span *ngIf="loadingResults" class="text-secondary">- Loading...</span>
    <span *ngIf="!loadingResults && resultList && resultList.results">({{ resultList.count.toLocaleString() }})</span>
  </h2>

  <div class="alert" role="alert"
       [class.alert-success]="history.state.feedback.status == 'success'"
       [class.alert-info]="history.state.feedback.status == 'info'"
       *ngIf="history && history.state && history.state.feedback">
    {{ history.state.feedback.text }}
  </div>

  <div class="row">
    <div class="col-xl-5 col-12 mb-3">
      <input type="text" class="form-control"
             placeholder="Filter discounts by code and name"
             [(ngModel)]="filters.search"
             (ngModelChange)="handleFilterChange()">
    </div>
    <div class="col-xl-7 col-12 mb-3 clearfix">
      <div class="float-right">
        <a class="btn btn-success" routerLink="/events/setup/discounts/add">
          Create New Discount
        </a>
      </div>
    </div>
  </div>

  <div class="rounded-table-wrapper table-responsive-lg">
    <table class="table table-hover">

      <thead>
      <tr>
        <th scope="col">Type</th>
        <th scope="col">Code</th>
        <th scope="col">Name</th>
        <th scope="col">Amount</th>
        <th scope="col">Scope</th>
        <th scope="col">Start Date</th>
        <th scope="col">End Date</th>
        <th scope="col">Pricing Matrices</th>
      </tr>
      </thead>

      <tbody *ngIf="resultsPresent()">
      <tr *ngFor="let discount of resultList.results"
          style="cursor: pointer;"
          routerLink="/events/setup/discounts/{{ discount.id }}">
        <td>{{ discount.is_automatic ? 'Automatic' : 'Code' }}</td>
        <td>
          <span *ngIf="discount.code">{{ discount.code }}</span>
          <span *ngIf="!discount.code" class="text-muted">None</span>
        </td>
        <td>
          <span *ngIf="discount.name">{{ discount.name }}</span>
          <span *ngIf="!discount.name" class="text-muted">None</span>
        </td>
        <td>
          <span *ngIf="discount.discount_type === EventDiscountType.currency">
            {{ orgConfig.formatCurrency(discount.amount) }}
          </span>
          <span *ngIf="discount.discount_type === EventDiscountType.percentage">
            {{ discount.amount }}%
          </span>
        </td>
        <td>
          {{ discount.is_per_participant ? 'Per-Participant' : 'Per-Booking' }}
        </td>
        <td>
          <span *ngIf="discount.start_date">{{ dateStringFromISO8601(discount.start_date) }}</span>
          <span *ngIf="!discount.start_date" class="text-muted">None</span>
        </td>
        <td>
          <span *ngIf="discount.end_date">{{ dateStringFromISO8601(discount.end_date) }}</span>
          <span *ngIf="!discount.end_date" class="text-muted">None</span>
        </td>
        <td>
          <span *ngIf="discount.pricing_matrix_details.length === 1">1 pricing matrix</span>
          <span *ngIf="discount.pricing_matrix_details.length !== 1">{{ discount.pricing_matrix_details.length }} pricing matrices</span>
          <ng-container *ngFor="let pmd of discount.pricing_matrix_details.slice(0, 5)">
            <br>
            <i>
              {{ pmd.event_type_name }} - {{ pmd.name }}
              <span *ngIf="pmd.event_type_status === EventTypeStatus.draft">(Draft)</span>
              <span *ngIf="pmd.event_type_status === EventTypeStatus.retired">(Retired)</span>
            </i>
          </ng-container>
          <ng-container *ngIf="discount.pricing_matrix_details.length > 5">
            <br>
            <i>&#8230;</i>
          </ng-container>
        </td>
      </tr>
      </tbody>

      <tbody *ngIf="!resultsPresent()">
      <tr>
        <td colspan="99">
          {{ loadingResults ? 'Loading...' : 'No discounts' }}
        </td>
      </tr>
      </tbody>

    </table>
  </div>

  <div class="row">
    <div class="col-sm mb-2">
      <label for="resultsPerPage" class="pr-1 align-middle">
        Results per page:
      </label>
      <select id="resultsPerPage" class="form-control d-inline-block" style="width:80px;"
              [(ngModel)]="pageSize" (change)="pageNumber = 1;loadDiscounts()">
        <option [ngValue]="10">10</option>
        <option [ngValue]="25">25</option>
        <option [ngValue]="50">50</option>
        <option [ngValue]="100">100</option>
      </select>
    </div>
    <div class="col-sm">
      <nav aria-label="Customer pagination">
        <ul class="pagination justify-content-end">
          <li class="page-item" [class.disabled]="pageNumber <= 1">
            <button class="page-link" aria-label="Previous" [disabled]="pageNumber <= 1"
               (click)="setPage(pageNumber - 1)">
              <span aria-hidden="true">&laquo;</span>
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber > 2">
            <button class="page-link" (click)="setPage(pageNumber - 2)">
              {{ pageNumber - 2 }}
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber > 1">
            <button class="page-link" (click)="setPage(pageNumber - 1)">
              {{ pageNumber - 1 }}
            </button>
          </li>
          <li class="page-item active" aria-current="page">
            <button class="page-link" disabled>
              {{ pageNumber }}
              <span class="sr-only">(current)</span>
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber < lastPageNumber()">
            <button class="page-link" (click)="setPage(pageNumber + 1)">
              {{ pageNumber + 1 }}
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber < (lastPageNumber() - 1)">
            <button class="page-link" (click)="setPage(pageNumber + 2)">
              {{ pageNumber + 2 }}
            </button>
          </li>
          <li class="page-item" [class.disabled]="pageNumber >= lastPageNumber()">
            <button class="page-link" aria-label="Next" [disabled]="pageNumber >= lastPageNumber()"
               (click)="setPage(pageNumber + 1)">
              <span aria-hidden="true">&raquo;</span>
            </button>
          </li>
        </ul>
      </nav>
    </div>
  </div>

</div>
